    <app-dialog headerText="Browser Session Expired" headerGlyph="rotate-right" saveText="Reload" [showTopCancelButton]="false"
                 [body]="body" (save)="reload()"></app-dialog>

<ng-template #body>
        <p  role="dialog" i18n="XMSG|Body text for the Session Expiry Dialog@@sessionExpiry.body">
            Your browser session has expired. Reload the page to continue.
        </p>
</ng-template>

